import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DialogService,
    IHD_DIALOG_SCROLL_STRATEGY_PROVIDER,
} from './dialog.service';
import { DialogLoaderComponent } from './loader/dialog-loader.component';
import { DialogContainerComponent } from './dialog-container.component';
import { DialogConfirmComponent } from './confirm/dialog-confirm.component';
import { DialogDateComponent } from './date/dialog-date.component';
import { DialogSaveChangesComponent } from './save-changes/dialog-save-changes.component';

import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormValidationModule } from '../form-validation/form-validation.module';
import { ElementsModule } from '@shared/elements/elements.module';

@NgModule({
    declarations: [
        DialogContainerComponent,
    ],
    imports: [
        CommonModule,
        ElementsModule,
        TranslateModule,
        ReactiveFormsModule,
        PortalModule,
        OverlayModule,
        FormValidationModule,
        FormsModule,
    ],
    exports: [
        DialogContainerComponent
    ],
    
    providers: [DialogService, IHD_DIALOG_SCROLL_STRATEGY_PROVIDER],
})
export class DialogModule {}
